import { Panel } from './Panel';
import { useTranslate } from '@tolgee/react';
import { History, HistoryItemProps } from 'components/History';
import dayjs from 'lib/dayjs';
import { useMemo, useState } from 'react';
import { TodoRecord } from 'views/Conversation/Sider/ToDoBundle/OperationLog';
import { useOperationTitle } from 'views/Conversation/Sider/ToDoBundle/operationLogHooks';

interface HistoryProps {
  type: Todo.Type;
  operationLog: Todo.TodoInstance['operationLog'];
  storeId: string;
}

const Title = ({ data }: { data: Todo.OperationLog }) => {
  const title = useOperationTitle(data);
  return <div>{title}</div>;
};

export const LogHistory = (props: HistoryProps) => {
  const { operationLog, type, storeId } = props;
  const { t } = useTranslate();

  const [visible, setVisible] = useState(false);

  const items = useMemo(() => {
    const result: HistoryItemProps[] = [];
    operationLog.forEach((item) => {
      if (item.operationType === 'CHANGE_TYPE') {
        return;
      }

      result.push({
        title: <Title data={item} />,
        description: (
          <span className="text-xs text-[#84868C] mt-1.5">
            {dayjs(Number(item.createTime)).format('YYYY-MM-DD HH:mm:ss')}
          </span>
        ),
      });
    });
    return result;
  }, [operationLog]);

  return (
    <>
      <Panel
        title={t('processing_history')}
        titleExtra={
          <div
            className="text-[#515359] cursor-pointer hover:opacity-80"
            onClick={() => setVisible(true)}
          >
            {t('todo.明细')}
          </div>
        }
      >
        <History items={items} showAll={false} defaultShowCount={2} />
      </Panel>
      <TodoRecord
        visible={visible}
        onCancel={() => setVisible(false)}
        dataSource={operationLog}
        type={type}
        storeId={storeId}
      />
    </>
  );
};
